"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var list = __importStar(require("../list"));
var fp_ts_1 = require("fp-ts");
var M = __importStar(require("../managed"));
var T = __importStar(require("../effect"));
function queueUtils() {
    var ops = list.empty();
    var hasCB = {};
    function next(o) {
        if (hasCB.cb) {
            var cb = hasCB.cb;
            hasCB.cb = undefined;
            cb(o);
        }
        else {
            // TODO: figure out how to trigger if even possible
            /* istanbul ignore next */
            list.push(ops, o);
        }
    }
    return { ops: ops, hasCB: hasCB, next: next };
}
exports.queueUtils = queueUtils;
function runFromQueue(op, callback) {
    switch (op._tag) {
        case "error":
            callback(fp_ts_1.either.left(op.e));
            // this will never be called
            /* istanbul ignore next */
            // tslint:disable-next-line: no-empty
            return function () { };
        case "complete":
            callback(fp_ts_1.either.right(fp_ts_1.option.none));
            // tslint:disable-next-line: no-empty
            return function () { };
        case "offer":
            callback(fp_ts_1.either.right(fp_ts_1.option.some(op.a)));
            // tslint:disable-next-line: no-empty
            return function () { };
    }
}
exports.runFromQueue = runFromQueue;
function emitter(ops, hasCB) {
    return M.pure(T.async(function (callback) {
        var op = list.popUnsafe(ops);
        if (op !== null) {
            runFromQueue(op, callback);
        }
        else {
            hasCB.cb = function (o) {
                // TODO: figure out how to trigger if even possible, triggered by line 22
                /* istanbul ignore if */
                if (list.isNotEmpty(ops)) {
                    list.push(ops, o);
                    var op_1 = list.popUnsafe(ops);
                    if (op_1 !== null) {
                        runFromQueue(op_1, callback)();
                    }
                }
                else {
                    runFromQueue(o, callback)();
                }
            };
        }
        /* istanbul ignore next */
        return function (cb) {
            cb();
        };
    }));
}
exports.emitter = emitter;
